import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useState } from "react";
import { useIntl } from "react-intl";
import {
  IQuestion,
  Question,
  QuestionType,
  SaveQuestion,
} from "services/KnowfullyAdminClient";
import { Mode } from "types/common-types";
import translateError from "utils/translateError";
import QuestionForm, { QuestionFormSubmitValues } from "./QuestionForm";

type QuestionCreateFormProps = {
  organizationId: string;
  onQuestionCreated: (
    createdQuestion: IQuestion,
    createAnother?: boolean
  ) => void;
  onCancel: () => void;
};

const QuestionCreateForm = ({
  organizationId,
  onQuestionCreated,
  onCancel,
}: QuestionCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { questionService } = useGlobalContext();
  const [anotherQuestionInit, setAnotherQuestionInit] = useState<IQuestion>();
  const [formId, setFormId] = useState(0);

  const onSubmit = async (
    values: QuestionFormSubmitValues,
    createAnother?: boolean
  ) => {
    try {
      const saveResponse = await registerPromise(
        questionService.saveQuestion(
          new SaveQuestion({ ...values, organizationId })
        )
      );

      const createdQuestion = await registerPromise(
        questionService.getQuestionById(saveResponse.id)
      );
      
      onQuestionCreated(createdQuestion.data, createAnother);

      if (createAnother) {
        setAnotherQuestionInit(
          Question.fromJS({
            required: values.required ?? false,
            hasConfidenceLevels: values.hasConfidenceLevels ?? false,
            questionType: QuestionType.fromJS({ id: values.questionTypeId }),
          })
        );

        setFormId((prevState) => prevState + 1);
      }

      return saveResponse;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <QuestionForm
      key={formId}
      question={anotherQuestionInit}
      mode={Mode.Create}
      onSubmit={onSubmit}
      submitLabel={t({ id: "questionFormCreateButton" })}
      onCancel={onCancel}
    />
  );
};

export default QuestionCreateForm;
